export const selectedChatbotExportChanged = (selectedExportPermission, currentExportPermission) => {
  return selectedExportPermission?.length !== 0 && selectedExportPermission?.[0] !== currentExportPermission?.[0]
}

export const selectedChatbotCopyChanged = (selectedCopyPastePermission, currentCopyPastePermission) => {
  return (
    selectedCopyPastePermission?.length !== 0 && selectedCopyPastePermission?.[0] !== currentCopyPastePermission?.[0]
  )
}
export const projectDescriptionChanged = (projectDescription, currentDescription) => {
  return projectDescription?.trim() !== currentDescription?.trim()
}

export const selectedJurisdictionChanged = (selectedJurisdiction, currentJurisdiction) => {
  return (
    selectedJurisdiction
      .map((element) => element.STATE_ID)
      .sort((a, b) => a - b)
      .toString() !== [...currentJurisdiction].sort((a, b) => a - b).toString()
  )
}
export const selectedDataAggregationChanged = (selectedDataAggregation, currentDataAggregation) => {
  return (
    selectedDataAggregation
      ?.map((element) => element.key)
      ?.sort((a, b) => String(a).localeCompare(String(b)))
      ?.toString() !== [...currentDataAggregation].sort((a, b) => String(a).localeCompare(String(b))).toString()
  )
}

export const selectedFiltersChanged = (selectedFilters, currentFilters) => {
  const selectedKeys =
    selectedFilters
      ?.map((filter) => filter.FILTER_KEY)
      ?.sort()
      ?.toString() || ''
  const currentKeys = currentFilters?.sort()?.toString() || ''
  return selectedKeys !== currentKeys
}

export const selectedUseCasesChanged = (selectedUseCases, currentUseCases) => {
  return (
    [...(selectedUseCases || [])]?.sort((a, b) => a - b).toString() !==
    [...(currentUseCases || [])]?.sort((a, b) => a - b).toString()
  )
}

export const selectedBenefitsChanged = (selectedBenefits, currentBenefits) => {
  return (
    selectedBenefits
      ?.map((element) => element.id)
      ?.sort((a, b) => a - b)
      ?.toString() !== [...(currentBenefits || [])]?.sort((a, b) => a - b)?.toString()
  )
}

export const selectedWorkforcesChanged = (selectedWorkforces, currentWorkforces) => {
  return (
    selectedWorkforces
      ?.map((element) => element.id)
      ?.sort((a, b) => a - b)
      ?.toString() !== [...(currentWorkforces || [])]?.sort((a, b) => a - b)?.toString()
  )
}

export const projectNameChanged = (projectName, currentGroupName, projectNamesList) => {
  return (
    projectName &&
    projectName.trim() !== currentGroupName &&
    currentGroupName.trim() &&
    !projectNamesList.includes(projectName)
  )
}

export const clientNameChanged = (clientName, currentClientName, clientNamesList) => {
  return clientName?.trim() !== (currentClientName?.trim() && !clientNamesList.includes(clientName))
}

export const firstNameChanged = (firstName) => {
  return firstName.trim() !== ''
}

export const lastNameChanged = (lastName) => {
  return lastName.trim() !== ''
}

export const emailChanged = (emailAddress) => {
  return emailAddress.trim() !== ''
}

export const selectedPersonaChanged = (selectedPersona, currentPersona) => {
  return selectedPersona?.length !== 0 && selectedPersona?.[0] !== currentPersona?.[0]
}

export const selectedTrendAnalysisChanged = (selectedTrendAnalysis, currentTrendAnalysis) => {
  return selectedTrendAnalysis?.length !== 0 && selectedTrendAnalysis?.[0] !== currentTrendAnalysis?.[0]
}

export const selectedUserFeedbackChanged = (selectedUserFeedback, currentUserFeedback) => {
  return selectedUserFeedback?.length !== 0 && selectedUserFeedback?.[0] !== currentUserFeedback?.[0]
}
export const selectedChatbotChanged = (selectedChatbot, currentChatbot) => {
  return selectedChatbot?.length !== 0 && selectedChatbot?.[0] !== currentChatbot?.[0]
}

export const selectedExportToggleChanged = (selectedExportToggle, currentExportToggle) => {
  return selectedExportToggle?.length !== 0 && selectedExportToggle?.[0] !== currentExportToggle?.[0]
}

export const selectedPOIChanged = (selectedPOI, currentPOI) => {
  return (
    selectedPOI
      .map((element) => element.POI_ID)
      .sort((a, b) => a - b)
      .toString() !== [...currentPOI].sort((a, b) => a - b).toString()
  )
}
